import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EventListGetResponse, EventListQuery } from '../../../shared/interfaces/event.interfaces';

const basePath = '/event/account';

@Injectable({
  providedIn: 'root',
})

export class EventAccountService {
  constructor(private http: HttpClient) { }

  // Gets a filtered list of events for a specific account
  getEventsByAccount(accountId: number, EventListQuery: EventListQuery): Observable<EventListGetResponse> {
    let params = new HttpParams()
      .set('visibles', EventListQuery?.visibles ?? false)
      .set('rows', EventListQuery?.rows ?? 50)
      .set('first', EventListQuery?.first ?? 0)
      .set('sort_order', EventListQuery?.sort_order ?? 1)
      .set('sort_field', EventListQuery?.sort_field ?? 'id')
      .set('filters', JSON.stringify(EventListQuery?.filters ?? {}));

    // Solo agregar fechas si están definidas y no son vacías
    if (EventListQuery?.start_date && EventListQuery.start_date.trim() !== '') {
      params = params.set('start_date', EventListQuery.start_date);
    }
    
    if (EventListQuery?.end_date && EventListQuery.end_date.trim() !== '') {
      params = params.set('end_date', EventListQuery.end_date);
    }

    return this.http.get<EventListGetResponse>(`${basePath}/${accountId}`, { params });
  }
}